export default __webpack_public_path__ + "static/media/f25-product-focus-banner-mob.b28064ff.jpg";